class SafeLocalStorage {
    static getItem = (key: string) => localStorage.getItem(key);

    static setItem = (key: string, value: string) => {
        try {
            localStorage.setItem(key, value);
        } catch (err) {
            console.error(err);
        }
    };

    static removeItem = (key: string) => localStorage.removeItem(key);
}

export { SafeLocalStorage };
